global.apiurl = 'https://etang.kingsha.com/api/wp/v2'
global.apiurl_foodcats = apiurl + '/sport_food_category?per_page=30&fields=id,name,parent&parent=0'
global.apiurl_foods = apiurl + '/sport_food?per_page=100&fields=id,title,sport_food_category,meta_box&sport_food_category='
global.apiurl_motion_type = apiurl + '/sport_type?per_page=100&fields=id,title,meta_box'
global.apiurl_sugar_foodcats = apiurl + '/index_food_category?per_page=30&fields=id,name,parent&parent=0'
global.apiurl_sugar_foods = apiurl + '/index_food?per_page=100&fields=meta_box,title,id,index_food_category&index_food_category='
global.food_thumb_api = "https://img.p.kingsha.com/etang/"
global.sport_thumb_api = "https://img.p.kingsha.com/etang/sports/"
global.sport_type_api = apiurl + "/sport_category?fields=id,name,parent&parent="
global.jump_base = "https://etang.kingsha.com/weixin.php?op="
global.jumpornot = false


// WEBPACK FOOTER //
// ./src/config/global.js